import React from "react";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import LogoLoadingStill from "@src/sharedComponents/LogoLoadingStill/LogoLoadingStill";
import Modal from "@src/sharedComponents/Modal/Modal";
import TitleBlock from "@src/sharedComponents/PageHero/TitleBlock";

import styles from "./DataProcessingModal.module.css";

interface Props {
  headerTitle: string;
  headerSubTitle: string;
  footerTitle: string;
  footerSubTitle: string;
  onCancel?: () => void;
  onClose: () => void;
}

const DataProcessingModal: React.FC<Props> = ({
  headerTitle,
  headerSubTitle,
  footerTitle,
  footerSubTitle,
  onCancel,
  onClose,
}: Props) => {
  return (
    <Modal
      modalStyle={{ borderRadius: 40 }}
      className={styles.modal}
      closeModal={onClose}
    >
      <div className={styles.bodyContainer}>
        <TitleBlock
          className={styles.titleBlock}
          titleVariant="title1"
          title={headerTitle}
          subTitle={headerSubTitle}
        />

        <div className={styles.brandLoader}>
          <LogoLoadingStill noBackgroundColor />
        </div>

        <TitleBlock
          className={styles.titleBlock}
          titleVariant="title2"
          title={footerTitle}
          subTitle={footerSubTitle}
        />

        <div className={styles.buttonGroup}>
          {onCancel !== undefined && (
            <Button
              text={"Cancel"}
              variant={"outlined"}
              buttonType={"secondary"}
              onClick={onCancel}
              sx={{ flex: 1 }}
              style={{ flex: 1 }}
            />
          )}

          <Button
            text={"Close"}
            variant={"outlined"}
            buttonType={"secondary"}
            onClick={onClose}
            sx={{ flex: 1, marginLeft: "20px" }}
            style={{ flex: 1 }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DataProcessingModal;
